import { makeStyles, Theme } from "@material-ui/core";

export const Styles = makeStyles((theme: Theme) => ({
  rightContainer: {
    backgroundColor: "#ffffff",
    "& .track-button": {
      marginTop: 24,
      maxWidth: "100%",
    },
    "& .rightSide__search div": {
      maxWidth: "100%",
    },
    [theme.breakpoints.down(theme.breakpoints.values["slaptop"])]: {
      paddingTop: "110px !important",
    },
  },
  rightSide: {
    flex: 1,
    padding: "0 60px !important",
    [theme.breakpoints.down(theme.breakpoints.values["xldesktop"])]: {
      padding: "0 24px !important",
    },
    [theme.breakpoints.down(theme.breakpoints.values["tablet"])]: {
      padding: "0 17px !important",
    },
  },
  rightSideContent:{
    maxWidth: 600,
    [theme.breakpoints.down(theme.breakpoints.values["xldesktop"])]: {
      maxWidth: "unset",
    },
  },
  header: {
    padding: "40px !important",
    [theme.breakpoints.down(theme.breakpoints.values["xldesktop"])]: {
      padding: "40px 24px !important",
    },
    [theme.breakpoints.down(theme.breakpoints.values["slaptop"])]: {
      display: "none !important"
    },
  },
  haveAccountTxt:{
    [theme.breakpoints.down(theme.breakpoints.values["xldesktop"])]: {
      display: "none"
    },
  },
  leftContainer: {
    [theme.breakpoints.down(theme.breakpoints.values["slaptop"])]: {
      display: "none !important",
    },
  },
  titlePage: {
    marginBottom: "12px !important",
    [theme.breakpoints.down(theme.breakpoints.values["xldesktop"])]: {
      fontSize: "24px",
      lineHeight: "36px",
    },
  },
  subtitlePage:{
    fontWeight: 400,
    fontSize: "13px",
    lineHeight: "18px",
    color: "#111111",
    opacity: 0.7,
  },
  iconContainer: {
    width: 37,
    height: 37,
    "& img": {
      width: "100%",
      height: "100%",
    },
    marginRight: 15,
    [theme.breakpoints.down(theme.breakpoints.values["slaptop"])]: {
      marginRight: 0,
      marginBottom: 15,
    }
  },
  errorDescription: {
    marginLeft: 52,
    marginRight: -52,
    [theme.breakpoints.down(theme.breakpoints.values["slaptop"])]: {
      marginLeft: 0,
      marginRight: 0,
      textAlign: "center",
      "& .rightSide__desc": {
        marginBottom: 5,
      }
    },
    "& p": {
      fontSize: 18,
      lineHeight: "27px",
      opacity: 1,
    },
  },
  progress: {
    position: "absolute",
    top: "20%",
    left: "50%",
    transform: "translate(-50%, -20%)",
  },
  relativeSection: {
    position: "relative",
    width: "100%",
    height: "100%",
  },
  headerActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  [theme.breakpoints.between("sm", "md")]: {
    rightSideTitle: {
      fontSize: "24px !important",
      marginBottom: "12px !important",
    },
    leftContainer: {
      backgroundPosition: "20% center",
    },
  },
  titleSection: {
    [theme.breakpoints.down(theme.breakpoints.values["slaptop"])]: {
      flexDirection: "column",
      alignItems: "center",
    }
  },
  [theme.breakpoints.down("sm")]: {
    header: {
      paddingRight: "17px !important",
    },
    titleText: {
      textAlign: "center",
    },
    errorDescription: {
      margin: 0,
    }
  },
  [theme.breakpoints.down("xs")]: {
    rightSideTitle: {
      fontSize: "24px !important",
      marginBottom: "8px !important",
    },
  },
  [theme.breakpoints.down(theme.breakpoints.values["xldesktop"])]: {
    footer: {
      "& div": {
        right: 24,
      },
    },
  },
  [theme.breakpoints.down(theme.breakpoints.values["tablet"])]: {
    footer: {
      "& div": {
        right: 17,
      },
    },
  },
}));
